import { Platform, WebPlatformApi } from '@tofu/platform';
import { AuthController } from '../../types/auth-controller';
import { createJwt } from '../../types/jwt';
import { getFakeUsername } from '../../utils/get-fake-username';
import { AuthTokens } from '../../types/auth-tokens';
import { FanforgeApiClient } from '@hotpot-arcade/fanforge-api-client';
import { AuthClient } from '../../auth/create-auth';

export class WebAuthController implements AuthController {
  platform = Platform.Web;

  constructor(private platformApi: WebPlatformApi) {}

  async getHotpotAuthTokens(apiClient: FanforgeApiClient, authClient: AuthClient): Promise<AuthTokens> {
    const username = getFakeUsername();
    const signinResponse = await authClient.devSignIn({ username });
    if (!signinResponse || !signinResponse.ok) {
      throw new Error(`Failed to sign in`);
    }
    const token = await apiClient.auth.token.$post(
      {},
      {
        headers: {
          Authorization: `Bearer ${signinResponse.token}`,
        },
      }
    );
    if (!token.ok) {
      throw new Error(`Failed to get auth tokens`);
    }
    const { jwt } = await token.json();
    return AuthTokens.new(createJwt(jwt));
  }
}
